import { logger as E } from "../../shared-lib/index.js";
export function toggleLogging() {
  E.toggleLogging();
}